import {messageActionType} from "_constants";

export default [
    {
        id: messageActionType.CREATE_JIRA,
        name: 'Create Jira issue',
    },
    {
        id: messageActionType.VIEW_RESPONSE_PAYLOAD,
        name: 'View response payload',
    },
    {
        id: messageActionType.DELETE_MESSAGE,
        name: 'Delete',
        predicate: "isDeleteFromSourceSupported",
        switchValue: "isActive"
    },
    {
        id: messageActionType.ACTION_MESSAGE,
        name: 'Action',
        predicate: "isSupported",
        switchValue: "!isMessageActioned"
    },
    {
        id: messageActionType.UNDO_MESSAGE,
        name: 'Undo',
        predicate: "isSupported",
        switchValue: "isMessageActioned"
    },
    {
        id: messageActionType.BLACKLIST_POST,
        name: 'Blacklist post',
        predicate: "isBlacklistPostSupported",
        switchValue: "isActive"
    },
    {
        id: messageActionType.HIDE_MESSAGE,
        name: 'Hide',
        predicate: "isHideSupported",
        switchValue: "!hideStatus",
    },
    {
        id: messageActionType.UNHIDE_MESSAGE,
        name: 'Unhide',
        predicate: "isHideSupported",
        switchValue: "hideStatus"
    },
    {
        id: messageActionType.LIKE_MESSAGE,
        name: 'Like',
        predicate: "isLikeSupported",
        switchValue: "isActive"
    },
    {
        id: messageActionType.POSITIVE_FEEDBACK,
        name: 'Positive feedback',
        predicate: "isSupported",
        switchValue: "isActive"
    },
    {
        id: messageActionType.CONSTRUCTIVE_FEEDBACK,
        name: 'Constructive feedback',
        predicate: "isSupported",
        switchValue: "isActive"
    },
    {
        id: messageActionType.LOW_PRIORITY_MESSAGE,
        name: 'Mark as low priority for practice',
        predicate: "isPriorityForPracticeSupported",
        switchValue: "priorityForPracticeStatus"
    },
    {
        id: messageActionType.HIGH_PRIORITY_MESSAGE,
        name: 'Mark as high priority for practice',
        predicate: "isPriorityForPracticeSupported",
        switchValue: "!priorityForPracticeStatus"
    },
]